import React from "react"
import { bool, func } from "prop-types"

import Button from "shared/components/Button/Button"
import Modal from "shared/components/ModernModal/index"
import Typograph from "components/Typograph"

import styles from "./styles.css"
import PadlockSvg from "assets/svg/icon-padlock.svg"

const AccessDeniedModal = ({ isOpen, onRedirect }) => (
  <Modal isOpen={isOpen} onClose={onRedirect} renderFooter={false}>
    <div className={styles.icon}>
      <img src={PadlockSvg} alt="" />
    </div>
    <Typograph
      style={{ textAlign: "center", marginBottom: "16px" }}
      htmlTag="p"
      preset="p"
      size="medium"
      color="outer_space"
      weight="bold"
    >
      Conteúdo restrito
    </Typograph>
    <Typograph
      style={{ textAlign: "center" }}
      htmlTag="p"
      preset="p"
      size="medium"
      color="outer_space"
      weight="medium"
    >
      Seu perfil não possui permissão para acessar esta página e será
      redirecionado à página inicial. Solicite o acesso ao administrador.
    </Typograph>
    <div className={styles.actions}>
      <Button onClick={onRedirect} width="small">
        OK
      </Button>
    </div>
  </Modal>
)

AccessDeniedModal.propTypes = {
  isOpen: bool.isRequired,
  onRedirect: func.isRequired
}

export default AccessDeniedModal



// WEBPACK FOOTER //
// ./src/components/AccessDeniedModal/index.js